import type { GuitarChart } from '../guitarChart.js';
import type { Variant } from '../gameTypes.js';
import { PALETTE_CRIMSON } from '../builtinPulseMaps/palettes.js';
import { assembleImportedGuitarChart } from './importedGuitarChart.js';
import normalImported from './imported/my-heart-normal.guitar.json' with { type: 'json' };
import hardImported from './imported/my-heart-hard.guitar.json' with { type: 'json' };
import extremeImported from './imported/my-heart-extreme.guitar.json' with { type: 'json' };

export const MY_HEART_GUITAR_VARIANTS: Record<Variant, GuitarChart> = assembleImportedGuitarChart({
  baseSlug: 'my-heart',
  baseTitle: "Heart Afire",
  description: "Defqwop's Heart Afire mapped by KingKensius. Drum & bass groove, monotonic difficulty across all three diffs.",
  difficulty: 5,
  palette: PALETTE_CRIMSON,
  audioSrc: '/audio/guitar/my-heart.mp3',
  attribution: "\"Heart Afire\" by Defqwop (feat. Strix) [NCS Release] - https://ncs.io/HeartAfire",
  imported: {
    normal: normalImported,
    hard: hardImported,
    extreme: extremeImported,
  },
});
